import React, { useContext, useState } from 'react';
import Button from '../button';
import { Modal } from '../modal';
import Input from '../input';
import Switch from '../switch';
import ToastContext from '../../context/toast';
import { CardVariant, IWithdrawCard } from '../../interface/cards';
import { useWithdraCard } from '../../services/cards';
import { capitalized } from '../../utils/capitalize';
import Dropdown from '../dropdown';

interface IWithdarwCardProps {
  cardId: string;
  variant: string;
}

const WithdarwCard = ({ cardId, variant }: IWithdarwCardProps) => {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState<IWithdrawCard>({} as IWithdrawCard);
  const [openSecretModal, setOpenSecretModal] = useState(false);
  const [showToken, setShowToken] = useState<boolean>(false);
  const { mutate, isLoading } = useWithdraCard();
  const { addToast } = useContext(ToastContext);

  const submit = () => {
    if (!payload?.secret) {
      addToast({
        msg: 'Please enter access Key',
        type: 'error',
      });
      return;
    }
    mutate(
      {
        ...payload,
        cardId,
        business: payload.business || false,
        withdrawToUser: payload.withdrawToUser || false,
        variant,
      },
      {
        onSuccess: () => {
          setOpenSecretModal(false);
          addToast({
            msg: 'Successfully Updated',
            type: 'success',
          });
        },
      }
    );
  };

  const openAccessModal = () => {
    if (!payload.amount) {
      addToast({
        msg: 'Please enter an amount',
        type: 'error',
      });
      return;
    } else {
      setOpen(false);
      setOpenSecretModal(true);
    }
  };

  return (
    <div className=" w-auto">
      <Button
        bgColor="bg-red-500"
        onClick={() => {
          setOpen(true);
        }}
      >
        Withdraw
      </Button>
      <Modal
        isVisible={open}
        close={setOpen}
        center
        width="medium"
        header
        padding
        overflow
        title="Wthdraw from card"
        showFooter
        footer={
          <div className="flex justify-end">
            <Button onClick={openAccessModal}>Withdraw</Button>
          </div>
        }
      >
        <div className="flex flex-col gap-2">
          <div className="py-2">
            <small className="text-xs">Amount</small>
            <Input
              defaultValue={payload?.amount}
              onChange={(e) => {
                setPayload({ ...payload!, amount: Number(e?.target.value) });
              }}
            />
          </div>
          <div className="py-2 flex justify-between items-center">
            <small className="text-xs">Withdraw to User</small>
            <Switch
              checked={payload?.withdrawToUser!}
              onCheck={() =>
                setPayload({
                  ...payload!,
                  withdrawToUser: !payload?.withdrawToUser,
                })
              }
            />
          </div>
          <div className="py-2 flex justify-between items-center">
            <small className="text-xs">Business</small>
            <Switch
              checked={payload?.business!}
              onCheck={() =>
                setPayload({ ...payload!, business: !payload?.business })
              }
            />
          </div>
        </div>
      </Modal>
      <Modal
        padding={false}
        isVisible={openSecretModal}
        center
        close={setOpenSecretModal}
        title="Enter Access Key"
        header
        width="medium"
        showFooter
        footer={
          <div className="flex justify-end gap-2">
            <Button loading={isLoading} disabled={isLoading} onClick={submit}>
              Submit
            </Button>
          </div>
        }
      >
        <div className="p-4">
          <p className="pb-2">
            <small className="w-1/4 text-textDimGray">Access key</small>
          </p>
          <Input
            name="secret"
            type={showToken ? 'text' : 'password'}
            value={payload?.secret}
            onChange={(e) =>
              setPayload({ ...payload!, secret: e.target.value })
            }
            trailing={
              <p
                onClick={() => setShowToken(!showToken)}
                className="text-sm text-blue"
              >
                Show
              </p>
            }
          />
        </div>
      </Modal>
    </div>
  );
};

export default WithdarwCard;
